// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__CbHmy","bold":"styles_bold__sK-iY"};